import React, { useState } from "react";
import axios from "axios";

const BACKEND_BASE_URL = process.env.REACT_APP_HOST || "https://backend.edgent.in/";

const ModeratorLogin = () => {
  const [masterKey, setMasterKey] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await axios.post(`${BACKEND_BASE_URL}m0d-7x9k2/auth/`, {
        master_key: masterKey,
        email: email.trim().toLowerCase(),
      });

      const { access_token, refresh_token, user: userData } = res.data;

      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      // Set expiration to 24 hours from now (same as regular login)
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem("token_expiration", expirationTime.toString());

      setUser(userData);
    } catch (err) {
      setError(err.response?.data?.error || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  const goToDashboard = () => {
    if (user?.role === "mentor") {
      window.location.href = "/dashboard";
    } else {
      window.location.href = "/dashboard";
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Moderator Access</h2>

        {!user ? (
          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="password"
              placeholder="Master Key"
              value={masterKey}
              onChange={(e) => setMasterKey(e.target.value)}
              style={styles.input}
              required
            />
            <input
              type="email"
              placeholder="User Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
            {error && <p style={styles.error}>{error}</p>}
            <button type="submit" style={styles.button} disabled={loading}>
              {loading ? "Authenticating..." : "Login as User"}
            </button>
          </form>
        ) : (
          <div style={styles.success}>
            <p>Logged in as:</p>
            <p style={styles.userName}>
              {user.first_name} {user.last_name}
            </p>
            <p style={styles.userEmail}>{user.email}</p>
            <p style={styles.userRole}>Role: {user.role}</p>
            <button onClick={goToDashboard} style={styles.button}>
              Go to Dashboard
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0a0a0a",
    padding: "20px",
  },
  card: {
    background: "#1a1a1a",
    padding: "40px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
  },
  title: {
    color: "#fff",
    marginBottom: "24px",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 500,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  input: {
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid #333",
    background: "#0a0a0a",
    color: "#fff",
    fontSize: "15px",
    outline: "none",
  },
  button: {
    padding: "14px 24px",
    borderRadius: "8px",
    border: "none",
    background: "#fff",
    color: "#0a0a0a",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    marginTop: "8px",
  },
  error: {
    color: "#ff6b6b",
    fontSize: "14px",
    margin: 0,
  },
  success: {
    textAlign: "center",
    color: "#fff",
  },
  userName: {
    fontSize: "18px",
    fontWeight: 600,
    margin: "8px 0 4px",
  },
  userEmail: {
    color: "#888",
    margin: "0 0 4px",
  },
  userRole: {
    color: "#4ade80",
    marginBottom: "20px",
  },
};

export default ModeratorLogin;
